export const lineHeights = {
  title: "3rem",
  subTitle:"2rem",
  paragraph:"1.7rem",
};
